<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="d-none justify-center menu-header d-sm-flex">
        <div class="container">
            <v-slide-group
                    v-model="model"
                    mandatory
                    show-arrows
                    class="centered-menu-carousel"
            >
                <v-slide-item
                        v-for="item in categoryItems"
                        :key="item.id"
                >
                    <div class="position-relative">
                        <v-menu
                                open-on-hover
                                allow-overflow
                                offset-y
                                bottom
                                class="ma-4"
                                content-class="full-width-menu"
                                v-model="isNavigationOpen[item.id]"
                        >
                            <template v-slot:activator="{ on }">
                                <v-btn
                                        class="mx-2 white--text body-2 py-4"
                                        text
                                        v-on="on"
                                        :to="item.url"
                                        @click.native="closeNavigation(item.id)"
                                >
                                    <v-img
                                        :src="`${getCdnPath()}/icons/${item.icon}-white.svg`"
                                        class="menu-icon"
                                    ></v-img>
                                    <span>&nbsp;{{item.localName}}</span>
                                </v-btn>
                            </template>
                            <v-card outlined class="border border-transparent">
                                <v-list class="pa-0">
                                    <v-row>
                                        <v-col
                                                cols="12"
                                                sm="4"
                                                v-for="sub in item.subCategories"
                                                :key="sub.id"
                                                class="pa-0"
                                        >
                                            <v-list-item
                                                    @click=""
                                                    link
                                                    class="button-hover px-0"
                                            >
                                                <v-btn
                                                        class="button-hover black--text body-2 py-4 px-0 text-capitalize"
                                                        text
                                                        link
                                                        :to="sub.url"
                                                        width="100%"
                                                >{{ sub.localName }}</v-btn>
                                            </v-list-item>
                                        </v-col>
                                    </v-row>
                                </v-list>
                            </v-card>
                        </v-menu>
                    </div>
                </v-slide-item>
            </v-slide-group>
        </div>
    </div>
</template>

<script>
    import './categoriesMenu.scss'
    import CategoriesDataMixin from '../../../app-front/mixins/CategoriesData';
    import AppVariables from "../../mixins/AppVariables";
    export default {
        name: "CategoriesMenu",
        components: {
        },
        mixins: [
            CategoriesDataMixin,
            AppVariables
        ],
        data() {
            return {
                mainRef: 'categoriesMenu',
                model: null,
                isNavigationOpen: {}
            }
        },
        methods: {
            closeNavigation(id) {
                this.isNavigationOpen[id] = false;
            }
        }
    }
</script>

<style scoped>
    .background-yellow {
        background: rgba(245, 184, 33, 0.8);
    }
    .menu-icon {
        width: 24px;
        height: 24px;
    }
</style>
